export const excelToJsonMapper = {
  'Codigo': 'Codigo',
  'Descripcion': 'Nombre Producto' ,
  'TipoProducto': 'Tipo Producto',
  'IdCategoria': 'Categoria',
  'IdSubCategoria': 'Sub Categoria',
  'ParametrizacionContableProducto0': 'Inventario',
  'ParametrizacionContableProducto1': 'Ventas',
  'ParametrizacionContableProducto2': 'Costo de Ventas',
  'ParametrizacionContableProducto4': 'Devolución Compras',
  'ParametrizacionContableProducto5': 'Devolución Ventas',
  'PrecioVentaConIva1': 'Precio de venta',
  'PrecioVentaConIva2': 'Precio Mayoreo',
  'PrecioVentaConIva3': 'Precio Mayoreo',
  'PorcentajeIva': 'Porcentaje Iva',
  'weight': 'Peso',
  'brand': 'Marca',
  'tallas': 'Tallas',
  'colores': 'Colores',
}